import { StepHeader } from "@/components/StepHeader";
import { StepLayout } from "./StepLayout";

const countries = [
  { name: "UAE", flag: "uae.svg" },
  { name: "Oman", flag: "oman.svg" },
  { name: "Qatar", flag: "qatar.svg" },
  { name: "KSA", flag: "ksa.svg" },
  { name: "Bahrain", flag: "bahrain.svg" },
  { name: "Kuwait", flag: "kuwait.svg" },
];

interface RegionSelectionProps {
  onRegionSelect: (region: string) => void;
}

export const RegionSelection = ({ onRegionSelect }: RegionSelectionProps) => {
  return (
    <StepLayout currentStep={1} showImportantNote={false} showReference={true}>
      <div className="mx-auto max-w-4xl text-center">
        {/* Region Selection Icon */}
        <StepHeader
          title="Select Your Region"
          subTitle="Select your region to get started with the right information"
          image="/images/icons/select-region-icon.svg"
        />

        {/* Country Grid */}
        <div className="mx-auto mt-2 grid max-w-2xl grid-cols-3 gap-2">
          {countries.map((country) => (
            <button
              key={country.name}
              onClick={() => onRegionSelect(country.name)}
              className="group flex flex-col items-center space-y-4 rounded-lg p-2 transition-all duration-300 hover:bg-white hover:shadow-lg sm:p-4"
            >
              <div className="h-16 w-16 overflow-hidden rounded-full opacity-60 shadow-md transition-all duration-300 group-hover:scale-110 group-hover:opacity-100 group-hover:shadow-xl sm:h-24 sm:w-24">
                <img
                  src={`/images/countries/${country.flag}`}
                  alt={`${country.name} Flag`}
                  className="h-full w-full object-cover"
                />
              </div>
              <span className="text-lg font-medium text-gray-700">
                {country.name}
              </span>
            </button>
          ))}
        </div>
      </div>
    </StepLayout>
  );
};
